export default __webpack_public_path__ + "static/media/web_screen_engage_es.faac2b76.png";